import React, { useState } from "react";

import { useModals } from "../../PurchaseFlow/NewCheckoutWrapper/providers/ModalsProvider";

import Stack from "react-bootstrap/Stack";

import { FlexPack } from "./FlexPack";
import { VouchersModal } from "./VouchersModal";

export default function FlexPacksList({ flexPacks }) {
  const { openModal } = useModals();

  const [show, setShow] = useState(false);

  // flex pack we are viewing
  const [flexPack, setFlexPack] = useState();

  const handleClose = () => {
    setShow(false);
    setFlexPack();
  };

  const handleShow = (fl) => {
    setShow(true);
    setFlexPack(fl);
  };

  const handleOpen = (desc) => {
    console.log("open modal", desc);
    openModal("Description", desc);
  };

  return (
    <>
      <Stack gap={3} as="ul">
        {flexPacks?.map((item, idx) => (
          <FlexPack
            key={item?.flex_pack?.uuid ?? item?.flex_pack?.id ?? idx}
            flexPack={{
              ...item?.flex_pack,
              vouchers: item?.vouchers,
            }}
            handleShow={handleShow}
            handleOpen={handleOpen}
          />
        ))}
      </Stack>

      <VouchersModal
        show={show}
        handleClose={handleClose}
        flexPack={flexPack}
      />
    </>
  );
}
